module.exports = __webpack_public_path__ + "static/item-3-f6fffc793ba9ca89c0a8a50ce6960a66.jpeg";